import React, { ReactNode } from "react";
import { Box, SxProps, Typography, TypographyProps } from "@mui/material";
import InfoIcon from "@icons/myicons/info2.svg?react";
import { Tooltip } from "./Tooltip";

interface Props extends TypographyProps {
  children: string | ReactNode;
  tooltipTitle?: string;
  tooltipText?: ReactNode;
  tooltipSmall?: boolean;
  openOnClick?: boolean;
  iconColor?: string;
  hideIcon?: boolean;
  icon?: ReactNode;
  iconSize?: number;
  containerSx?: SxProps;
  truncate?: boolean;
}

const truncateContainerStyles = {
  flex: 1,
  minWidth: 0,
  overflow: "hidden",
};

const truncateTypographyStyles = {
  display: "block",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  minWidth: 0,
};

export const TypographyWithInfoIcon = ({
  children,
  tooltipTitle,
  tooltipText,
  tooltipSmall,
  openOnClick,
  hideIcon,
  containerSx,
  icon = <InfoIcon />,
  iconColor,
  iconSize,
  truncate,
  ...rest
}: Props) => {
  return (
    <Box
      sx={{
        textWrap: "wrap",
        ...(truncate && truncateContainerStyles),
        ...containerSx,
      }}
    >
      {!hideIcon && (
        <Typography
          component="span"
          sx={{
            verticalAlign: "middle",
            ...(truncate && truncateTypographyStyles),
            ...rest.sx,
          }}
          {...rest}
        >
          {children}
        </Typography>
      )}
      {(tooltipText || tooltipTitle) && (
        <Tooltip
          title={tooltipTitle}
          text={tooltipText}
          isSmall={tooltipSmall}
          placement="top"
          openOnClick={openOnClick}
        >
          {hideIcon ? (
            <Typography
              component="span"
              sx={{
                ...(truncate && truncateTypographyStyles),
                ...rest.sx,
              }}
              {...rest}
            >
              {children}
            </Typography>
          ) : (
            <Box
              display="inline-flex"
              color={iconColor || "text.secondary"}
              sx={{
                cursor: "help",
                verticalAlign: "middle",
                marginTop: -0.5,
                "& svg": {
                  width: iconSize,
                  height: iconSize,
                },
              }}
              ml={1.5}
            >
              {icon}
            </Box>
          )}
        </Tooltip>
      )}
    </Box>
  );
};
